import { useMemo } from 'react';
export function usePagination(meta, defaultPageSize = 10) {
    return useMemo(() => {
        var _a, _b, _c;
        return ({
            total: (_a = meta === null || meta === void 0 ? void 0 : meta.total_count) !== null && _a !== void 0 ? _a : 0,
            showSizeChanger: false,
            page: (_b = meta === null || meta === void 0 ? void 0 : meta.page) !== null && _b !== void 0 ? _b : 1,
            pageSize: (_c = meta === null || meta === void 0 ? void 0 : meta.limit) !== null && _c !== void 0 ? _c : defaultPageSize
        });
    }, [meta === null || meta === void 0 ? void 0 : meta.total_count, meta === null || meta === void 0 ? void 0 : meta.current_page, meta === null || meta === void 0 ? void 0 : meta.limit, defaultPageSize]);
}
